import dayjs from 'dayjs'
import React, { useContext, useEffect, useState } from 'react'
import { GetUserReferencedList } from '../../ApiServices/UserWallet/UserWalletApi';
import { LoaderContext } from '../../AuthContext/AuthContext';
import ReferAndEarn from './ReferAndEarn';

const ReferAndEarnHistory = () => {
    const [transactionData, setTransactionData] = useState([])
    const { setLoader } = useContext(LoaderContext);
    const userID = localStorage.getItem("userID")
    useEffect(() => {
        GetUserReferencedListData()
    }, [])

    const GetUserReferencedListData = async () => {
        setLoader(true);
        try {
            let response = await GetUserReferencedList(userID); // Replace with actual import/function call
            if (response?.ResponseCode == "0") {
                setLoader(false);
                const list = response?.DATA || [];
                setTransactionData(list)


            } else {
                console.error("Bad request");
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };
    return (
        <>
            <ReferAndEarn />
            
          <div
  className="wallet-history-section history-responsive"
  style={{
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "40px 0",
    background: "#fafafa",
  }}
>
  <div
    className="wallet-table-wrapper"
    style={{
      width: "95%",
      maxWidth: "1200px",
    }}
  >
    {transactionData?.length > 0 ? (
      <div
        className="card p-3"
        style={{
          borderRadius: "12px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          backgroundColor: "#fff",
          width: "100%",
          overflowX: "auto",
        }}
      >
        <table
          className="wallet-table"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "left",
            fontSize: "15px",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#a52444", color: "#fff" }}>
              <th style={{ padding: "12px 16px", whiteSpace: "nowrap" }}>
                Referrer Name
              </th>
              <th style={{ padding: "12px 16px", whiteSpace: "nowrap" }}>
                Referral Name
              </th>
              <th style={{ padding: "12px 16px", whiteSpace: "nowrap" }}>
                Wallet Amount (₹)
              </th>
              <th style={{ padding: "12px 16px", whiteSpace: "nowrap" }}>
                Registered Date
              </th>
              <th style={{ padding: "12px 16px", whiteSpace: "nowrap" }}>
                Remarks
              </th>
            </tr>
          </thead>

          <tbody>
            {transactionData.map((value, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#f8f9fa",
                  borderBottom: "1px solid #e0e0e0",
                  transition: "background 0.2s",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#fff3f6")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background =
                    index % 2 === 0 ? "#fff" : "#f8f9fa")
                }
              >
                <td style={{ padding: "12px 16px" }}>
                  {value.ReferredByName || "N/A"}
                </td>
                <td style={{ padding: "12px 16px" }}>
                  {value.ReferredToName || "N/A"}
                </td>
                <td style={{ padding: "12px 16px" }}>
                  {value.WalletAmount?.toFixed(2) || "0.00"}
                </td>
                <td style={{ padding: "12px 16px" }}>
                  {value.RegDate || "N/A"}
                </td>
                <td style={{ padding: "12px 16px" }}>
                  {value.Note || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <h5
        style={{
          textAlign: "center",
          color: "#6c757d",
          fontWeight: 500,
          marginTop: "20px",
        }}
      >
        No transaction history found.
      </h5>
    )}
  </div>
</div>

        </>
    )
}

export default ReferAndEarnHistory
